/**
 * Find the word located in the string with a numeric index.
 */
export default function getClosestWord(str, pos): string {
  // Perform type conversions.
  str = String(str)
  pos = Number(pos) >>> 0

  // Search for the word's beginning and end.
  const left = str.slice(0, pos + 1).search(/\S+$/),
    right = str.slice(pos).search(/\s/)

  // The last word in the string is a special case.
  if (right < 0) {
    return str.slice(left)
  }

  // Return the word, using the located bounds to extract it from the string.
  return str.slice(left, right + pos)
}
